<template>
  <!--
    A CONFIRMAÇÃO, em papel. Só existe para o que o D11 permite confirmar — dinheiro real e
    destruição (sair do clã, dissolver, expulsar); ação reversível não passa por aqui. A ação
    perigosa usa a placa de perigo; a de cancelar é a neutra.
  -->
  <FishModal :aberto="true" :titulo="title || $t('common.confirm')" @fechar="$emit('cancel')">
    <p class="confirmar__mensagem">{{ message }}</p>

    <template #acoes>
      <FishButton tamanho="pequeno" som="clique" @click="$emit('cancel')">
        {{ cancelText || $t('common.cancel') }}
      </FishButton>
      <FishButton
        :variante="type === 'danger' || type === 'warning' ? 'perigo' : 'primario'"
        tamanho="pequeno"
        som="clique"
        @click="$emit('confirm')"
      >
        {{ confirmText || $t('common.confirm') }}
      </FishButton>
    </template>
  </FishModal>
</template>

<script>
import { FishModal, FishButton } from '@/shared/ui';

export default {
  name: 'ConfirmModal',
  components: { FishModal, FishButton },
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'warning', 'danger', 'success'].includes(value)
    },
    /** Mantido por compatibilidade com quem passava ícone; o papel dispensa o sino. */
    icon: {
      type: String,
      default: ''
    }
  },
  emits: ['confirm', 'cancel'],
};
</script>

<style scoped>
.confirmar__mensagem {
  margin: 0;
  font-size: var(--f-2);
  color: var(--tinta);
  line-height: var(--lh-normal);
}
</style>
